import React from "react";

import {
  Form,
  Row,
  Col,
  Button,
  Input,
  Select,
  Icon,
  Checkbox,
  Radio,
  DatePicker,
} from "antd";
import MiCompAPI from "../../util/api";

import img from "../../assets/img/At the office-pana 1.png";

const plainOptions = ["Plan A", "Plan B", "Plan C"];
class FD extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.api = new MiCompAPI(this.props.userPermandMasters);
  }

  componentDidMount() {}
  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <div className="mi_model_popup" style={{ padding: "40px" }}>
        {" "}
        <Row span={24}>
          <Col span={18}>
            <p style={{ marginLeft: "14px" }} className="mi_title">
              Add Service Request
            </p>
          </Col>
          <Col span={6}>
            <i
              className="fa fa-times mi_icon mi_icon_red mi_button_close"
              style={{ color: "red" }}
              onClick={this.props.closeDrawerHandler}
            ></i>
          </Col>
        </Row>
        <Form onSubmit={this.handleSubmit} layout="vertical" hideRequiredMark>
          <Row span={24}>
            <Col md={24} sm={24}>
              {this.props.SelectedTemplate &&
              this.props.SelectedTemplate.length > 0 ? (
                this.props.SelectedTemplate.map((x) => {
                  if (x.fieldTypeName === "textarea") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <fieldset
                              style={{ height: "auto" }}
                              className="mi_input_pop"
                            >
                              <legend className="legend-font">
                                {x.fieldLabel}
                              </legend>
                              {getFieldDecorator("fieldPlaceHolder", {
                                rules: [
                                  {
                                    required: true,
                                    message: "Please enter Description.",
                                  },
                                ],
                              })(
                                <Input.TextArea
                                  type="text"
                                  style={{ height: "100px" }}
                                  autoComplete={"nope"}
                                  className="mi_input"
                                  placeholder={x.fieldPlaceHolder}
                                />
                              )}
                            </fieldset>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "date") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <fieldset className="mi_input_pop">
                              <legend className="legend-font">
                                {" "}
                                {x.fieldLabel}
                              </legend>

                              <DatePicker
                                autoComplete={"nope"}
                                format="MM/DD/YYYY"
                                className="mi_input"
                                placeholder={x.fieldPlaceHolder}
                              />
                            </fieldset>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "text") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <fieldset
                              style={{ height: "auto" }}
                              className="mi_input_pop"
                            >
                              <legend className="legend-font">
                                {x.fieldLabel}
                              </legend>

                              <Input
                                className="mi_input"
                                maxLength={40}
                                type="text"
                                placeholder={x.fieldPlaceHolder}
                              />
                            </fieldset>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "email") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <fieldset
                              style={{ height: "auto" }}
                              className="mi_input_pop"
                            >
                              <legend className="legend-font">
                                {x.fieldLabel}
                              </legend>

                              <Input
                                className="mi_input"
                                maxLength={40}
                                type="text"
                                placeholder={x.fieldPlaceHolder}
                              />
                            </fieldset>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "radio") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <legend
                              className="legend-font"
                              style={{
                                marginLeft: "14px",
                              }}
                            >
                              {x.fieldLabel}
                            </legend>

                            <Radio.Group
                              style={{
                                marginLeft: "16px",
                                marginTop: "20px",
                              }}
                              // value={this.state.usertype}
                            >
                              <Radio className="micompradio" value="male">
                                Male
                              </Radio>
                              <Radio className="micompradio" value="female">
                                Female
                              </Radio>
                            </Radio.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "select") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <fieldset
                              style={{ height: "auto" }}
                              className="mi_input_pop"
                            >
                              <legend className="legend-font">
                                {x.fieldLabel}
                              </legend>

                              <Select
                                suffixIcon={
                                  <Icon
                                    style={{ transform: "rotate(90deg)" }}
                                    type="double-right"
                                  />
                                }
                                className="mi_input_profile"
                                style={{ width: "150px" }}
                                placeholder="Please Select"
                                showSearch={true}
                                filterOption={(input, option) =>
                                  option.props.children
                                    .toLowerCase()
                                    .indexOf(input.toLowerCase()) >= 0
                                }
                              ></Select>
                            </fieldset>
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                  if (x.fieldTypeName === "checkbox") {
                    return (
                      <Row span={24}>
                        <Col md={12} sm={24}>
                          <Form.Item>
                            <legend
                              className="legend-font"
                              style={{
                                marginLeft: "14px",
                              }}
                            >
                              {x.fieldLabel}
                            </legend>

                            <Checkbox.Group
                              style={{
                                marginLeft: "18px",

                                borderColor: "#4E5693",
                              }}
                              options={plainOptions}
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                    );
                  }
                })
              ) : (
                <></>
              )}
            </Col>
          </Row>

          <Row></Row>

          <Row span={24} style={{ marginTop: "30px" }}>
            <Col span={7}></Col>

            <Col span={5}>
              <Button
                className="mi_button_right submit-button"
                onClick={this.props.closeDrawerHandler}
                style={{ marginRight: 8 }}
              >
                Cancel
              </Button>
            </Col>
            <Col span={5}>
              <Button
                htmlType="submit"
                className="submit-button"
                type="primary"
              >
                Submit
              </Button>
            </Col>
            <Col span={7}>
              <img
                alt="example"
                style={{
                  height: "70px",
                  marginBottom: "-30px",
                  float: "right",
                }}
                src={img}
              />
            </Col>
            <Col span={7}></Col>
          </Row>
        </Form>
      </div>
    );
  }
}
const AddRequest = Form.create()(FD);
export default AddRequest;
